module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.containerClass,
    attrs: {
      "role": "separator"
    }
  }, [(_vm.$slots.default) ? _c('div', {
    staticClass: "p-divider-content"
  }, [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4609b5fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/divider/Divider.vue
// module id = 2194
// module chunks = 0